/* eslint-disable import/export */
import Stack from "./Stack";
export * from "./Stack";
export default Stack;